if (!customElements.get('p2r-about-sync')) {
  customElements.define('p2r-about-sync', class extends HTMLElement {
    connectedCallback() {
      this.controller=new AbortController();
      const track=this.querySelector('.gallery-track'),button=this.querySelector('[data-pause]');
      if(!track||!button)return;
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      let paused=motion.matches,hover=false,visible=false;
      const label=()=>{button.textContent=paused?'Play gallery':'Pause gallery';button.setAttribute('aria-pressed',String(paused));};
      const on=(el,type,fn,extra={})=>el.addEventListener(type,fn,{signal:this.controller.signal,...extra});
      on(button,'click',()=>{paused=!paused;label();});
      on(track,'pointerenter',()=>{hover=true;});
      on(track,'pointerleave',()=>{hover=false;});
      on(track,'touchstart',()=>{paused=true;label();},{passive:true});
      on(motion,'change',()=>{if(motion.matches){paused=true;label();}});
      this.observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;});
      this.observer.observe(track);
      this.timer=setInterval(()=>{
        if(paused||hover||!visible||document.hidden||track.contains(document.activeElement))return;
        const step=track.querySelector('img').getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
        track.scrollTo({left:track.scrollLeft>=track.scrollWidth-track.clientWidth-2?0:track.scrollLeft+step,behavior:motion.matches?'instant':'smooth'});
      },5000);
      label();
    }
    disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.controller?.abort();}
  });
}
